<template>
  <ya-site-resource-list resource="hotel" />
</template>

<script>
import YaSiteResourceList from './resourceList'

export default {
  name: 'YaSiteHotelList',
  components: { YaSiteResourceList },
}
</script>
